import { faMapMarker } from '@fortawesome/free-solid-svg-icons'
import { GoogleMap, Marker, Polyline } from '@react-google-maps/api'
import React, { useEffect, useMemo, useState } from 'react'
import { calculoAreaCoord, getBoundsNoArray } from '../../../../../../../../services/Afins'
import { getPedLaboratorio } from '../../../../../../../../services/Laboratorio'
import { destroyAlert, loadingAlert } from '../../../../../../../../utils/alert'
import { ModalVisualizarMapa } from './styled'

interface PropsVisuMaps {
    open: boolean
    update: number
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

/** Opções fixas de todos os marcadores — referência estável para não recriar por ponto. */
const MARKER_OPTIONS: google.maps.MarkerOptions = {
    clickable: false,
    draggable: false,
}
/**Modal para apenas visualizar os pontos do mapa */
export const VisualizarMapaTabela: React.FC<PropsVisuMaps> = (props) => {
    const { open, update, setOpen } = props

    const [geoJson, setGeoJson] = useState<any>([])
    const [kmlAnalise, setKmlAnalise] = useState({})
    const [grupoAnalises, setGrupoAnalises] = useState([])
    const [malha, setMalha] = useState<any>([])
    const [map, setMap] = useState<google.maps.Map>()

    const [listLinha, setListLinha] = useState<google.maps.LatLngLiteral[]>([])
    const linha = () => {
        //@ts-ignore
        const polyline: google.maps.LatLngLiteral[] = kmlAnalise.coordenadas?.map((rec) => {
            return {
                lat: Number(rec.latitude),
                lng: Number(rec.longitude),
            }
        })
        setListLinha(polyline)
    }

    async function buscarAnalise() {
        // limpa o talhão anterior para não "piscar" o dado antigo enquanto carrega o novo
        setGeoJson([])
        setMalha([])
        setListLinha([])
        loadingAlert({ msg: 'Carregando...', id: 'loading_outro' })
        const resp = await getPedLaboratorio(update)
        const dados = resp.data.itens[0]
        setKmlAnalise(dados.talhao_kml)
        setGrupoAnalises(dados.analises)
        setMalha(dados.malha_de_pontos)
        destroyAlert('loading_outro')
    }

    useEffect(() => {
        if (malha?.features) {
            linha()
            setGeoJson(malha)
        }
    }, [malha])

    useEffect(() => {
        // só enquadra quando há pontos; a lista vazia é o reset entre aberturas
        if (map && listLinha?.length) {
            const bounds = getBoundsNoArray(listLinha)
            map.fitBounds(bounds)
        }
    }, [listLinha])

    useEffect(() => {
        if (update > 0) {
            buscarAnalise()
        }
    }, [update])

    /**
     * Parte do ícone que é IGUAL para todos os marcadores.
     * Só é criado depois que a API do Google carregou (map definido) e
     * recriado apenas quando isso muda — evita instanciar google.maps.Point
     * por ponto a cada render.
     */
    const iconBase = useMemo(() => {
        if (!map) return null
        return {
            path: faMapMarker.icon[4] as string,
            anchor: new window.google.maps.Point(190, 550),
            fillColor: '#ffffff',
            fillOpacity: 1,
            strokeWeight: 1,
            strokeColor: '#ffffff',
            scale: 0.055,
            labelOrigin: new window.google.maps.Point(190, 220),
        }
    }, [map])

    /** Lista de marcadores já pronta — só recalcula quando geoJson ou o ícone base mudam. */
    const marcadores = useMemo(() => {
        if (!iconBase || !geoJson?.features) return []
        return geoJson.features.map((data) => ({
            key: data.properties.INDICE,
            text: parseInt(data.properties.NOME, 10).toString(),
            lat: parseFloat(data.geometry.coordinates[1]),
            lng: parseFloat(data.geometry.coordinates[0]),
        }))
    }, [geoJson, iconBase])

    /** Área do talhão memoizada — evita recalcular calculoAreaCoord 3x por render. */
    const areaTalhao = useMemo(() => calculoAreaCoord([listLinha]), [listLinha])
    const qtdPontos = geoJson?.features?.length ?? 0

    return (
        <ModalVisualizarMapa
            forceRender
            open={open}
            onCancel={() => setOpen(false)}
            footer={null}
            closable={true}
            style={{ minHeight: '81vh', minWidth: '65%', top: 10 }}
            destroyOnClose
        >
            <div className='VisualizarMapa__header'>
                <h3>Visualizar pontos</h3>
            </div>
            <div className='VisualizarMapa__infos'>
                <div>
                    <label>Área do talhão</label>
                    <p>{areaTalhao} ha</p>
                </div>
                <div>
                    <label>Total de pontos</label>
                    <p>{qtdPontos}</p>
                </div>
                <div>
                    <label>Grid amostral</label>
                    <p>{(areaTalhao / qtdPontos).toFixed(2)} ha/pontos</p>
                    {/* <p>???????</p> */}
                </div>
            </div>
            <div className='VisualizarMapa__mapa'>
                <GoogleMap
                    onLoad={setMap}
                    options={{
                        mapTypeId: 'satellite',
                        mapTypeControl: false,
                        streetViewControl: false,
                        clickableIcons: true,
                    }}
                    mapContainerStyle={{
                        width: '100%',
                        height: '71vh',
                        border: '2px solid #d9d9d9',
                        borderRadius: '5px',
                    }}
                >
                    {marcadores.map((ponto) => (
                        <Marker
                            key={ponto.key}
                            // @ts-ignore
                            icon={iconBase}
                            options={MARKER_OPTIONS}
                            label={{
                                className: 'color-marker-label',
                                text: ponto.text,
                                fontSize: '11px',
                                fontWeight: 'bold',
                            }}
                            position={{ lat: ponto.lat, lng: ponto.lng }}
                        />
                    ))}
                    <Polyline
                        options={{
                            path: listLinha,
                            geodesic: true,
                            strokeColor: '#00f75b',
                            strokeOpacity: 1.0,
                            strokeWeight: 4,
                            zIndex: 0,
                        }}
                    />
                </GoogleMap>
            </div>
        </ModalVisualizarMapa>
    )
}
